module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h2', [_vm._v("Page Not Found")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c31ef8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/404.vue
// module id = 695
// module chunks = 1